import { Controller } from 'stimulus';

class Header extends Controller {
  connect() {
    this.isFixed = false;
    this.scrollOffset = document.querySelector('.top-bar').offsetHeight;

    window.addEventListener('scroll', this.onWindowScroll.bind(this));
  }

  disconnect() {
    window.removeEventListener('scroll', this.onWindowScroll.bind(this));
  }

  onWindowClick(e) {
    const headerParent = e.target.closest('[data-controller="header"]');

    if (!headerParent) {
      this.closeAllDropdowns();
    }
  }

  closeAllDropdowns() {
    const dropdowns = Array.prototype.slice.call(this.element.querySelectorAll('.collapse.show'));

    dropdowns.forEach((dropdown) => {
      $(dropdown).collapse('hide');
    });
  }

  onWindowScroll() {
    const top = window.scrollY;

    if (top > this.scrollOffset && !this.isFixed) {
      this.isFixed = true;
      this.setFixedState();
    } else if (top <= this.scrollOffset && this.isFixed) {
      this.isFixed = false;
      this.setFixedState();
    }
  }

  setFixedState() {
    this.element.classList[this.isFixed ? 'add' : 'remove']('is-fixed');
  }
}

Header.targets = [
  //
];

export default Header;
